/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_State_UpcomingInputs */

const vi_station_work_state_upcoming = /** @type {(inputs: Station_Work_State_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp tới`)
};

/**

* @param {Station_Work_State_UpcomingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_state_upcoming = /** @type {((inputs?: Station_Work_State_UpcomingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_State_UpcomingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_state_upcoming(inputs)
});